(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/javascripts/utils.js');

'use strict';

const drawsApi = svs.numbergames.draws.drawsApi;
function hasPassedGenereateEndTime(_ref) {
  let productNumeric = _ref.productNumeric,
    stopGenerateMinutes = _ref.stopGenerateMinutes;
  const currentCloseTime = drawsApi.currentRegCloseTime(productNumeric);
  if (!currentCloseTime) return true;
  const generateEndTime = dateFns.subMinutes(new Date(currentCloseTime), stopGenerateMinutes);
  return dateFns.isAfter(drawsApi.clientNow(), generateEndTime);
}
Object.assign(svs.numbergames.fractiongames.utils, {
  hasPassedGenereateEndTime
});

 })(window);